import {Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {MatChipsModule} from "@angular/material/chips";
import {MatIconModule} from "@angular/material/icon";
import {MatTooltipModule} from "@angular/material/tooltip";
import {User} from "@modules/user/models/user.model";
import {ShareDirectivesModule} from "@shared/share-directives/share-directives.module";

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatChipsModule,
    MatIconModule,
    NgOptimizedImage,
    MatTooltipModule,
    ShareDirectivesModule
  ],
  selector: 'app-user-chip[user]',
  templateUrl: './user-chip.component.html',
  styleUrls: ['./user-chip.component.scss']
})
export class UserChipComponent implements OnInit {
  @Input() user: User
  @Input() hideRemoveAction: boolean = true
  @Output() remove = new EventEmitter<User>()

  constructor() {
  }

  ngOnInit(): void {
  }

  removeUser(user: User) {
    this.remove.emit(user)
  }
}
